import { createSelector } from "reselect";
import { dataSelector } from "src/selectors/data_selectors/data_selector";

export const woundAssessmentProgressChartDataSelector = createSelector(
  dataSelector,
  data => data.woundAssessmentProgressChartData
);
